/**
 * Les étapes — sélection de l'étape affichée.
 *
 * Les panneaux existent tous dans le HTML : on ne fait que basculer l'attribut
 * hidden, donc aucune image n'est chargée au changement d'étape.
 *
 * Clavier : flèches pour passer d'une étape à l'autre, Début et Fin pour aller
 * aux extrémités, conformément au motif d'onglets ARIA.
 */
(() => {
  document.querySelectorAll('[data-oyw-etapes]').forEach((section) => {
    const onglets = [...section.querySelectorAll('[role="tab"]')];
    const panneaux = [...section.querySelectorAll('[role="tabpanel"]')];
    if (onglets.length === 0) return;

    let actif = 0;

    const activer = (index, donnerLeFocus = false) => {
      actif = (index + onglets.length) % onglets.length;

      onglets.forEach((onglet, i) => {
        const choisi = i === actif;
        onglet.setAttribute('aria-selected', String(choisi));
        onglet.tabIndex = choisi ? 0 : -1;
      });

      panneaux.forEach((panneau, i) => {
        panneau.hidden = i !== actif;
      });

      if (donnerLeFocus) onglets[actif].focus();
    };

    onglets.forEach((onglet, index) => {
      onglet.addEventListener('click', () => activer(index));

      onglet.addEventListener('keydown', (evenement) => {
        const pas = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[evenement.key];
        if (pas) {
          evenement.preventDefault();
          activer(actif + pas, true);
          return;
        }
        if (evenement.key === 'Home') {
          evenement.preventDefault();
          activer(0, true);
        } else if (evenement.key === 'End') {
          evenement.preventDefault();
          activer(onglets.length - 1, true);
        }
      });
    });

    // Les flèches « Précédent » et « Suivant » de chaque panneau tournent en boucle.
    section.querySelectorAll('[data-oyw-etape-prec]').forEach((bouton) => {
      bouton.addEventListener('click', () => activer(actif - 1));
    });
    section.querySelectorAll('[data-oyw-etape-suiv]').forEach((bouton) => {
      bouton.addEventListener('click', () => activer(actif + 1));
    });
  });
})();
